// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.props-img-wrap[data-v-729a01b4] {\r\n  font-size: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
